<template>
  <div :class="getScreen ? 'm-page-wrapper' : 'd-page-wrapper'">
    <div v-if="id === null || id === undefined">
      <a-card class="m-wrong">
        <m-anim
          :options="notfound"
          class="anim"
          :height="getScreen ? 200 : 500"
          :width="getScreen ? 200 : 500"
        ></m-anim>
        <h3>>Not Found</h3>
        <p>
          Return to the previous page and make the selection manifest again!
        </p>
        <a-button type="primary" block>
          <router-link to="/po">
            <a-icon type="rollback" />&nbsp; Return
          </router-link>
        </a-button>
      </a-card>
    </div>
    <div v-else>
      <a-row :gutter="8">
        <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
          <a-card :loading="loading" class="margin-bottom">
            <div slot="title">
              Payment Manifest
              <small class="m-display-block m-text-small">{{
                data.manifest.no_payment
              }}</small>
            </div>

            <div class="m-card-body">
              <ul class="m-list-wrapper bordered">
                <li>
                  <span class="m-list-title" for>Date Created</span>
                  <span class="m-list-desc"
                    >{{
                      data.manifest.date_create
                        ? moment(
                            data.manifest.date_create,
                            getStandartFormatDate
                          ).format(getDefaultDateFormat)
                        : "-"
                    }}
                  </span>
                </li>
                <li>
                  <span class="m-list-title" for>TLC Create</span>
                  <span class="m-list-desc">{{
                    data.manifest.tlc_create
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>No. Transaksi</span>
                  <span class="m-list-desc">{{
                    data.manifest.no_financing
                      ? data.manifest.no_financing
                      : "-"
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Detil Financing</span>
                  <span class="m-list-desc">{{
                    data.manifest.seq_bulan_tahun
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Type Financing</span>
                  <span class="m-list-desc">{{
                    data.manifest.type_financing
                  }}</span>
                </li>
                <li>
                  <span class="m-list-title" for>Value Pokok</span>
                  <span class="m-list-desc">
                    {{
                      data.manifest.currency
                        ? formatCurrency(
                            data.currency,
                            data.manifest.value_biaya_pokok
                          )
                        : "-"
                    }}
                  </span>
                </li>
                <li>
                  <span class="m-list-title" for>Value Bunga</span>
                  <span class="m-list-desc">
                    {{
                      data.manifest.currency
                        ? formatCurrency(
                            data.currency,
                            data.manifest.value_bunga
                          )
                        : "-"
                    }}
                  </span>
                </li>
                <li>
                  <span class="m-list-title" for>Total Value</span>
                  <span class="m-list-desc">
                    {{
                      data.manifest.currency
                        ? formatCurrency(
                            data.currency,
                            data.manifest.value_total_value
                          )
                        : "-"
                    }}
                  </span>
                </li>
              </ul>
            </div>
          </a-card>

          <a-card
            class="margin-top"
            v-if="data.jenis === 'Transfer' && status_transfer"
          >
            <div slot="title">
              Manifest Actions &nbsp;<i
                v-if="data.jenis == 'Transfer' && !status_transfer"
                style="color: red !important"
                >(Funding has not been set)</i
              >
            </div>
            <div class="m-text-align right margin-remove" slot="extra">
              <h5 class="m-text-align right margin-remove">
                remaining balance
              </h5>
              <a-tag color="green" class="m-text-align right margin-remove">{{
                formatCurrency(data.currency, sisa_tf)
              }}</a-tag>
            </div>
            <template v-if="!(data.jenis == 'Transfer' && !status_transfer)">
              <a-form :form="form">
                <a-row :gutter="16">
                  <a-form-item label="Status">
                    <a-select
                      @change="onChangeStatus"
                      v-decorator="[
                        'status',
                        {
                          rules: [{ required: true }],
                          initialValue: data.aksi[0].aksi,
                        },
                      ]"
                    >
                      <a-select-option v-for="da in data.aksi" :key="da.aksi">{{
                        da.aksi
                      }}</a-select-option>
                    </a-select>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Date">
                    <a-date-picker
                      placeholder="Select Date"
                      :format="dateFormat"
                      v-decorator="['tgl_tf', { rules: [{ required: true }] }]"
                    />
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Upload Bukti Transfer">
                    <a-upload
                      :fileList="fileList"
                      :disabled="fileList.length > 0"
                      v-decorator="[
                        'file_transfer',
                        { rules: [{ required: reqFileTf }] },
                      ]"
                      accept=".jpg, .png, .pdf"
                      :remove="handleRemove"
                      :beforeUpload="beforeUpload"
                    >
                      <a-button> <a-icon type="upload" />Select File </a-button>
                    </a-upload>
                  </a-form-item>

                  <a-form-item v-if="reqFileTf" label="Transfer Value">
                    <a-checkbox
                      :defaultChecked="true"
                      @change="onchangeNilaiTf"
                      :checked="checkTransferValue"
                      >Transfer value according to remaining balance</a-checkbox
                    >
                    <a-input-number
                      :min="0.1"
                      :max="sisa_tf"
                      class="m-display-block"
                      v-decorator="[
                        'value_transferan',
                        {
                          rules: [{ required: true }],
                          initialValue: temp_sisa_tf,
                        },
                      ]"
                      :disabled="disableNilaiTf"
                    ></a-input-number>
                  </a-form-item>

                  <a-form-item label="Note">
                    <a-textarea
                      placeholder="Write the note here ... "
                      :rows="4"
                      v-decorator="[
                        'catatan',
                        { rules: [{ required: false }] },
                      ]"
                    />
                  </a-form-item>
                </a-row>
                <a-form-item :wrapper-col="{ span: 24 }">
                  <a-button
                    @click="handleActionConfirm"
                    block
                    type="primary"
                    html-type="submit"
                    >Save</a-button
                  >
                </a-form-item>
              </a-form>
            </template>
          </a-card>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
          <a-collapse :class="getScreen ? 'margin-top' : ''" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Transfer Receipt</h4>
              </div>
              <ul class="m-list-wrapper bordered">
                <li
                  v-for="(dbt, index) in data.detailBuktiTransfer"
                  :key="index"
                >
                  <div
                    slot="title"
                    class="m-display-flex space-between align-middle nowrap"
                  >
                    <h4 class="margin-remove m-text-dots">
                      {{ dbt.tgl_tf }} | {{ dbt.tlc }}
                    </h4>
                    <a-upload
                      class="upload-custom"
                      :fileList="dbt.fileList"
                      @preview="handlePreview"
                    ></a-upload>
                    <a-modal
                      :visible="previewVisible"
                      :footer="null"
                      @cancel="handleCancel"
                    >
                      <div class="margin-top"></div>
                      <a-divider class="margin-small" />
                      <img
                        alt="example"
                        style="width: 100%"
                        :src="previewImage"
                      />
                    </a-modal>
                  </div>
                  <div class="m-display-flex space-between align-middle">
                    <p slot="description">
                      {{ formatCurrency(data.currency, dbt.value_tf) }}
                    </p>
                  </div>
                </li>
              </ul>
            </a-collapse-panel>
          </a-collapse>
          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Status</h4>
                <div>
                  <Status :status="data.last_status" />
                  <a-button
                    @click="historyToggle"
                    type="default"
                    size="small"
                    class="margin-right-small"
                  >
                    <a-icon type="undo" />
                  </a-button>
                </div>
              </div>
              <a-timeline class="m-timeline">
                <a-timeline-item color="green">
                  <div class="m-timeline-title">
                    Pembuat - {{ data.manifest.tlc_create }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove">
                      {{
                        moment(data.manifest.date_created).format(
                          getDateTimeFormat
                        )
                      }}
                    </h4>
                    <span
                      class="m-text-small"
                      v-if="data.manifest.description"
                      >{{ data.manifest.description }}</span
                    >
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <a-tag color="green">Created</a-tag>
                  </div>
                </a-timeline-item>
                <a-timeline-item
                  v-for="workflow in data.status"
                  :key="workflow.step_no"
                >
                  <div class="m-timeline-title">
                    {{ workflow.actor }} - {{ workflow.tlc }}
                  </div>
                  <div class="m-timeline-body">
                    <h4 class="margin-remove" v-if="workflow.tanggal_aksi">
                      {{
                        moment(workflow.tanggal_aksi).format(getDateTimeFormat)
                      }}
                    </h4>
                    <span class="m-text-small" v-if="workflow.remark">{{
                      workflow.remark
                    }}</span>
                    <span class="m-text-small" v-else>Tidak Ada Catatan</span>
                  </div>
                  <div class="m-timeline-footer">
                    <Status :status="workflow.status" />
                  </div>
                </a-timeline-item>
              </a-timeline>
            </a-collapse-panel>
          </a-collapse>

          <a-collapse class="margin-top" activeKey="1">
            <a-collapse-panel key="1">
              <div
                class="m-display-flex space-between align-middle"
                slot="header"
              >
                <h4 class="margin-remove">Related Document</h4>
              </div>

              <a-list
                itemLayout="horizontal"
                :dataSource="data.dokumen_terkait"
              >
                <Empty
                  v-if="
                    data.dokumen_terkait
                      ? data.dokumen_terkait.length <= 0
                      : data.dokumen_terkait
                  "
                />
                <a-list-item slot="renderItem" slot-scope="item">
                  <a-list-item-meta>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                    >
                      <a
                        @click="
                          handleView({
                            ...item,
                            id_manifest: item.id,
                          })
                        "
                        >{{ item.header }} | {{ item.user_pembuat }}</a
                      >
                      <Status
                        :class="!getScreen ? 'margin-remove' : ''"
                        :status="item.status"
                      />
                    </div>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                      v-if="item.no_trans"
                    >
                      <span>{{ item.no_trans }}</span>
                    </div>
                    <div
                      slot="title"
                      class="m-display-flex space-between align-middle"
                      v-if="item.value"
                    >
                      <span>{{ formatCurrency("IDR", item.value) }}</span>
                    </div>
                    <div slot="description" v-if="item.tgl">
                      <span
                        >{{
                          moment(item.tgl, getStandartFormatDate).format(
                            getDefaultDateFormat
                          )
                        }}
                      </span>
                    </div>
                    <div
                      slot="title"
                      v-if="
                        item.estimated_value && item.rest_api !== 'supplier'
                      "
                    >
                      <span class="m-timeline-title">{{
                        formatCurrency(item.currency, item.estimated_value)
                      }}</span>
                    </div>
                  </a-list-item-meta>
                </a-list-item>
              </a-list>
            </a-collapse-panel>
          </a-collapse>
        </a-col>
      </a-row>
    </div>

    <a-modal v-model="visibleHistory" @ok="historyToggle" :footer="null">
      <span slot="title"> <a-icon type="reload" />&nbsp;History Status </span>

      <ul class="m-list-wrapper bordered">
        <li v-for="history in data.history" :key="history.id_notifikasi">
          <div v-if="history.aksi === '1' || history.aksi === '3'">
            <div class="m-display-flex space-between">
              <h3 class="margin-remove m-list-title">
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
          <div v-else-if="history.aksi === '2' || history.aksi === '4'">
            <div class="m-display-flex space-between">
              <h3
                class="margin-remove m-list-title"
                v-if="history.aksi === '4' && history.deskripsi === 'Edited'"
              >
                {{ history.as_from }} | {{ history.tlc_from }}
              </h3>
              <h3 class="margin-remove m-list-title" v-else>
                {{ history.as_to }} | {{ history.tlc_to }}
              </h3>
              <Status :status="history.deskripsi" />
            </div>
            <span class="m-list-desc">{{ history.tgl_notif }}</span>
          </div>
        </li>
      </ul>
    </a-modal>
  </div>
</template>

<script>
import Axios from "axios";
import { mapGetters, mapActions } from "vuex";
import Status from "@/components/Status.vue";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import HandleRoute from "@/mixins/HandleRoute";
import lottie from "vue-lottie";
import notfound from "@/assets/anim/404.json";
import moment from "moment";
import _ from "lodash";
import ACol from "ant-design-vue/es/grid/Col";

export default {
  name: "PaymentManifest",
  components: {
    ACol,
    Status,
    "m-anim": lottie,
  },
  props: ["id", "user_pembuat"],
  mixins: [CurrencyFormat, HandleRoute],
  data() {
    return {
      notfound: { animationData: notfound, loop: true },
      previewVisible: false,
      previewImage: "",
      loading: false,
      visibleHistory: false,
      visibleLampiran: false,
      fileListLampiran: [],
      fileListModalLampiran: [],
      fileList: [],
      fileListModal: [],
      reqFileTf: true,
      disableNilaiTf: true,
      data: {
        detail_pembelian: [],
        dokumen_terkait: [],
        detailBuktiTransfer: [],
        manifest: {},
        status: [],
        history: [],
        total: {
          subTotal: "",
          grandTotal: "",
          nilaiPajak: "",
        },
        dokumen_butuh: [],
        lampiran: [],
        jenis: "",
        aksi: [],
      },
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      dateFormat: "DD MMMM YYYY",
      tlc: "",
      cek_value: 1,
      sisa_tf: "",
      temp_sisa_tf: "",
      currency: "",
      checkTransferValue: true,
      status_transfer: false,
    };
  },
  created() {
    this.$store.dispatch("FETCH_ALL_KURIR");
    this.$store.dispatch("FETCH_ALL_KARYAWAN");
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStandartFormatDate",
      "getAllGudang",
      "getDefaultDateFormat",
      "getIsSpecialMenu",
      "getDateTimeFormat",
      "getStatusShipment",
      "getAllKurir",
      "getAllKaryawan",
    ]),
  },
  methods: {
    ...mapActions(["FETCH_ALL_KURIR"]),
    moment,
    fetchManifest() {
      this.loading = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "payment_schedule",
        params: {
          tlc: this.getAuth.username,
          id_manifest: this.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.data = {
            currency: response.data.currency,
            manifest: response.data.header_1[0],
            status: response.data.status_transaksi[0].wf_status,
            history: response.data.status_transaksi[0].history,
            dokumen_terkait: response.data.related_dokumen,
            jenis: response.data.jenis,
            aksi: response.data.aksi,
            detailBuktiTransfer: response.data.bukti_tf,
          };
          this.sisa_tf = response.data.sisa_tf;
          this.temp_sisa_tf = this.sisa_tf;
          this.status_transfer = response.data.status;

          let dbt = this.data.detailBuktiTransfer;
          for (const [i, val] of dbt.entries()) {
            let name = i + 1 + val.path.substring(val.path.lastIndexOf("."));
            this.data.detailBuktiTransfer[i]["fileList"] = [
              {
                url: process.env.VUE_APP_SERVICEURL + val.path,
                uid: i,
                name: name,
                status: "done",
              },
            ];
          }

          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
            this.$router.go(-1);
          } else {
            this.displayMessage("denied-manifest");
            this.loading = false;
            this.$router.push({ name: "beranda" });
          }
        });
    },
    historyToggle(e) {
      e.stopPropagation();
      this.visibleHistory = !this.visibleHistory;
    },
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        if (this.data.jenis === "Transfer") {
          this.fileList.push(file);
        } else {
          this.fileListLampiran.push(file);
        }
        return false;
      }
    },
    handleRemove(file) {
      if (this.data.jenis === "Transfer") {
        const index = this.fileList.indexOf(file);
        const newFileList = this.fileList.slice();
        newFileList.splice(index, 1);
        this.fileList = newFileList;
      } else {
        const index = this.fileListLampiran.indexOf(file);
        const newFileList = this.fileListLampiran.slice();
        newFileList.splice(index, 1);
        this.fileListLampiran = newFileList;
      }
    },
    handleRemoveModal(file) {
      if (this.data.jenis === "Transfer") {
        const index = this.fileListModal.indexOf(file);
        const newFileList = this.fileListModal.slice();
        newFileList.splice(index, 1);
        this.fileListModal = newFileList;
      } else {
        const index = this.fileListModalLampiran.indexOf(file);
        const newFileList = this.fileListModalLampiran.slice();
        newFileList.splice(index, 1);
        this.fileListModalLampiran = newFileList;
      }
    },
    onchangeNilaiTf(e) {
      this.disableNilaiTf = e.target.checked;
      if (e.target.checked) {
        this.cek_value = 1;
        this.checkTransferValue = true;
        this.form.setFieldsValue({ value_transferan: this.sisa_tf });
      } else {
        this.cek_value = 0;
        this.checkTransferValue = false;
      }
    },
    handlePreview(file) {
      if (
        file.url.substr(file.url.length - 3) === "pdf" ||
        file.url.substr(file.url.length - 4) === "xlsx"
      ) {
        window.open(file.url, "_blank");
      } else {
        this.previewImage = file.url || file.thumbUrl;
        this.previewVisible = true;
      }
    },
    handleCancel() {
      this.previewVisible = false;
    },
    // handleViews(val) {
    //   if (val.rest_api === "financing") {
    //     let namemanifest = "financing-manifest";
    //     this.$router.push({
    //       name: namemanifest,
    //       params: {
    //         id: val.id,
    //       },
    //     });
    //   } else {
    //     this.handleView(val);
    //   }
    // },
    onChangeStatus(val) {
      if (val === "Transferred") {
        this.reqFileTf = true;
      }
    },
    handleActionConfirm() {
      this.confirmMessage("confirm-save");
    },
    handleAction() {
      if (this.data.jenis === "Transfer") {
        this.form.validateFields((err, values) => {
          if (err) {
            return;
          }
          let formData = new FormData();
          formData.append("tlc", this.getAuth.username);
          formData.append("id_manifest", this.id);
          formData.append("file_transfer", values.file_transfer.file);
          formData.append("remark", values.catatan);
          formData.append("status", "Transferred");
          formData.append(
            "tgl_transfer",
            moment(values.tgl_tf).format(this.getStandartFormatDate)
          );

          if (this.checkTransferValue) {
            formData.append("cek_value", 1);
            formData.append("value_transfer", 0);
          } else {
            formData.append("cek_value", 0);
            formData.append("value_transfer", values.value_transferan);
          }

          Axios({
            method: "post",
            url: this.$serviceUrl + "payment_schedule/approval",
            data: formData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
            .then((response) => {
              this.displayMessage("success");
              this.$router.go(0);
            })
            .catch((err) => {
              console.log("error : " + err);
            });
        });
      }
    },
  },
  mounted() {
    this.fetchManifest();
    Event.$on("refresh", this.fetchManifest);
    Event.$on("confirmMessageReturn", this.handleAction);
  },
  beforeDestroy() {
    Event.$off("refresh", this.fetchManifest);
    Event.$off("confirmMessageReturn", this.handleAction);
  },
  watch: {
    id() {
      if (this.id) {
        this.fetchManifest();
        this.form = this.$form.createForm(this);
        this.fileList = [];
        this.checkTransferValue = true;
        this.disableNilaiTf = true;
        this.reqFileTf = true;
      }
    },
  },
};
</script>

<style></style>
